import { SylPlugin } from '@syl-editor/core-utilities';
import ColorController from './controller';
import DIYColor from './schema';

export default class LinkPlugin extends SylPlugin<any> {
  public name = 'diyColor';

  public Controller = ColorController;

  public Schema = DIYColor;
}
